import { getMapData } from '@/lib/map';
import { mapKeys } from '@/services/query-keys/map';
import type { MapDataPayload } from '@/types/map';
import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { DabeeoMapData } from 'dabeeomaps';

export const useGetMapDataQuery = <TData = DabeeoMapData>(
    params: MapDataPayload,
    options?: Omit<UseQueryOptions<DabeeoMapData, unknown, TData, QueryKey>, 'queryKey'>
) => {
    const { error, isError, ...rest } = useQuery<DabeeoMapData, unknown, TData, QueryKey>({
        queryKey: mapKeys.getMapData(params),
        queryFn: async () => {
            const data = await getMapData(params);
            return data;
        },
        enabled: !!params?.clientId && !!params?.clientSecret,
        staleTime: Infinity,
        gcTime: Infinity,
        ...options,
    });

    return { error, isError, ...rest };
};
